<div class="notifications-overlay">
    <div class="notifications-container">
        @if (!isLoading()) {
            @for (notification of notifications(); track notification.id) {
                <div class="notification">
                    <mat-icon class="icon notification-{{ notification.type.toLowerCase() }}">
                        {{ notificationTypeIcons[notification.type] }}
                    </mat-icon>
                    <p class="message">
                        @if (!notification.referenceLink) {
                            <span>{{ notification.title }}</span>
                        } @else {
                            <a [href]="notification.referenceLink">{{ notification.title }}</a>
                        }
                    </p>
                    <span class="time">{{ notification.createdDate | localizedDate: 'short' }}</span>
                    <button
                        mat-icon-button
                        [matTooltip]="'Notifications.MarkAsRead' | translate"
                        (click)="confirmNotification(notification)">
                        <mat-icon>check</mat-icon>
                    </button>
                </div>
            } @empty {
                <div class="no-new-notifications">
                    {{ 'Notifications.NoNewNotifications' | translate }}
                </div>
            }
        } @else {
            <div class="loading">
                <mat-spinner [diameter]="32" />
            </div>
        }
    </div>
    <a mat-button class="see-all-button" routerLink="/notifications" (click)="closeOverlay()">
        <span>{{ 'Notifications.SeeAll' | translate }}</span>
        <mat-icon>chevron_right</mat-icon>
    </a>
</div>
